import { ReportType } from '@/types';
import client from './client';

async function create({
  type,
  variables,
}: {
  type: ReportType;
  variables: Record<string, unknown>;
}) {
  await client.post(`/generatorsLogs`, {
    type,
    variables,
  });
}

export const generatorsLogs = {
  create,
};
